import { render, staticRenderFns } from "./turnstile.vue?vue&type=template&id=5572ad18&"
import script from "./turnstile.vue?vue&type=script&lang=js&"
export * from "./turnstile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports